<template>
  <b-modal
    ref="productDetailModal"
    hide-footer
    :title="`${product.product_title}`"
    centered
    lazy
    scrollable
    @hide="hideModal"
    size="lg"
  >
    <div class="row">
      <div class="col-md-6">
        <product-image-carousel :product="product" :height="320" />
      </div>
      <div class="col-md-6">
        <div class="mb-0" style="text-transform: none">
          <h3>{{ product.product_title }}</h3>
          <strong>{{ $n(product.price, 'currency', 'en-US') }}</strong>
          <div v-if="productColors.length" class="my-3">
            <div class="d-flex align-items-baseline mb-2">
              <strong>Color</strong>
              <span class="color-picker__value ml-2">{{ color ? getProductColorName(product, color) : 'Select a color' }}</span>
            </div>
            <div class="d-flex flex-wrap">
              <button
                v-for="productColor in productColors"
                :key="productColor"
                type="button"
                class="color-picker__swatch"
                :class="{ 'color-picker__swatch--selected': color === productColor }"
                :style="{ '--swatch-color': productColor }"
                :title="getProductColorName(product, productColor)"
                :aria-label="`Select color ${getProductColorName(product, productColor)}`"
                :aria-pressed="color === productColor ? 'true' : 'false'"
                @click.prevent="color = productColor"
              >
                <i
                  v-if="color === productColor"
                  class="material-icons color-picker__check"
                  :style="{ color: getContrastColor(productColor) }"
                  >check</i
                >
              </button>
            </div>
          </div>
          <div v-if="get(product, 'sizes')" class="mb-2">
            <div class="custom-select-icon" style="min-width: 50px">
              <b-form-select class="custom-select-icon__select" v-model="size" :options="sizeOptions"> ></b-form-select>
              <span class="material-icons custom-select-icon__icon">sort</span>
            </div>
          </div>

          <div class="d-flex justify-content-between">
            <span class="mt-1" style="font-size: 1.5rem">
              <a class="clickable-item" @click.prevent="decrementQuantity(product)"
                ><i class="fas fa-minus-square"></i
              ></a>
              {{ $n(quantity) }}
              <a class="clickable-item" @click.prevent="incrementQuantity(product)"
                ><i class="fas fa-plus-square"></i
              ></a>
            </span>
            <b-btn variant="light" style="width: 150px" @click.prevent="addToCart" class="btn-normal float-right">
              <span>Add To Cart</span>
            </b-btn>
          </div>

          <div class="mt-2">
            <h5 class="mb-1" style="text-transform: capitalize">Description</h5>
            <p>{{ product.product_description }}</p>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { get } from 'lodash';
import { getContrastColor } from '@/common/utils';
import { getProductColorName } from '@/common/colorNames';
import ProductImageCarousel from '@/components/ProductImageCarousel.vue';
export default {
  components: { ProductImageCarousel },
  props: {
    showModal: { type: Boolean, default: false },
    product: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      quantity: 1,
      size: null,
      color: null,
      sizeOptions: [{ value: null, text: 'Please Select', disabled: true }],
    };
  },
  computed: {
    productColors() {
      return get(this.product, 'colors.length') ? this.product.colors : this.product.color ? [this.product.color] : [];
    },

    isMobSmallScreen() {
      return this.windowWidth <= 420;
    },
  },
  watch: {
    showModal(value) {
      if (value) {
        this.$refs.productDetailModal.show();
        this.sizeOptions = this.sizeOptions.concat(this.product.sizes);
      }
    },
  },
  methods: {
    get,
    getContrastColor,
    getProductColorName,
    addToCart() {
      this.makeToast({ variant: 'success', msg: 'Product added successfully.' });
      this.$emit('add', this.product, this.quantity, this.size, this.color);
      this.quantity = 1;
    },
    incrementQuantity() {
      this.quantity += 1;
    },
    decrementQuantity() {
      if (this.quantity > 1) {
        this.quantity -= 1;
      }
    },
    hideModal() {
      this.quantity = 1;
      this.sizeOptions = [{ value: null, text: 'Please Select', disabled: true }];
      this.size = null;
      this.color = null;
      this.$emit('close');
    },

    hideModalManual() {
      this.$refs.productDetailModal.hide();
      this.hideModal();
    },
  },
};
</script>

<style scoped>
.color-picker__value {
  font-size: 13px;
  color: #868e96;
  letter-spacing: 0.02em;
}

.color-picker__swatch {
  position: relative;
  width: 30px;
  height: 30px;
  margin: 0 10px 10px 0;
  padding: 0;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 50%;
  background-color: var(--swatch-color);
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.14);
}

.color-picker__swatch:hover {
  transform: translateY(-2px);
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.2);
}

.color-picker__swatch:focus {
  outline: none;
}

.color-picker__swatch--selected {
  box-shadow: 0 0 0 2px #fff, 0 0 0 4px var(--swatch-color), 0 1px 3px rgba(0, 0, 0, 0.14);
}

.color-picker__check {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 16px;
}
</style>
